import React from 'react';
import '../styles/LightBox.scss';

const LightBox = ({ thumb, caption, onNext, onPrev }) => {
  const disableNav = !onPrev || !onNext;
  const className = `LightBox${disableNav ? ' --disable-nav' : ''}`;
  return (
    <div className={className}>
      <div className="caption">{caption}</div>
      <img src={thumb} alt="" />
      <div className="info">
        <div className="prev" onClick={onPrev}>prev</div>
        <div className="notice">Use arrow keys to navigate.</div>
        <div className="next" onClick={onNext}>next</div>
      </div>
    </div>
  );
};

LightBox.propTypes = {
  thumb: React.PropTypes.string,
  caption: React.PropTypes.string,
  onPrev: React.PropTypes.func,
  onNext: React.PropTypes.func
};

export default LightBox;



// WEBPACK FOOTER //
// ./src/components/LightBox.js